import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Checkbox, CustomSearchTree } from '@bringg/react-components';
import { NodeValues } from '@bringg/react-components/dist/components/home-made-tree/tree/checkbox-tree/hooks/use-checkbox-states';
import { observer } from 'mobx-react';
import { isEmpty } from 'lodash';
import { Webhook } from '@bringg-frontend/webhooks-api-internal-stores';

interface WebhookFieldsFormProps {
	webhook: Webhook;
	onChange: (nodeValues: NodeValues) => void;
	reset: () => void;
}

const WebhookFieldsForm: React.FC<WebhookFieldsFormProps> = ({ webhook, onChange, reset }: WebhookFieldsFormProps) => {
	const { t } = useTranslation();

	const { tree, rootId, nodeValues, mandatoryNodeIds } = webhook.webhookFieldsTree;
	const disabledNodes = new Set(mandatoryNodeIds);

	const [showOnlySelected, setShowOnlySelected] = useState(false);

	const filterNode = nodeId => {
		return showOnlySelected && nodeValues[nodeId] === false;
	};

	const isNotSupported = isEmpty(tree) && webhook.key;
	const emptyTreeText = isNotSupported ? t('FLEXIBLE_WEBHOOK.NOT_SUPPORTED') : t('FLEXIBLE_WEBHOOK.PLEASE_SELECT');

	return (
		<div className="webhook-fields-form">
			<div className="webhook-fields-description">
				<div className="webhook-fields-description-title">{t('FLEXIBLE_WEBHOOK.TITLE')}</div>
				<div className="webhook-fields-description-content">
					{t('FLEXIBLE_WEBHOOK.DESCRIPTION')}
					<div>
						<a href="https://developers.bringg.com/">https://developers.bringg.com/</a>
					</div>
				</div>
			</div>
			<div className="webhook-show-selected-checkbox">
				<Checkbox
					className="webhook-show-selected-checkbox-input"
					checked={showOnlySelected}
					onChange={e => {
						setShowOnlySelected(e.target.checked);
					}}
				/>
				<span className="webhook-show-selected-checkbox-text">{t('FLEXIBLE_WEBHOOK.SHOW_SELECTED')}</span>
			</div>
			<CustomSearchTree
				tree={tree}
				treeClassName="webhook-tree"
				className="tree-with-search"
				disabledNodes={disabledNodes}
				disableEntitiesSelection
				rootId={rootId}
				nodeValues={nodeValues}
				onChange={onChange}
				filterNode={filterNode}
				emptyTreeTranslation={emptyTreeText}
				searchPlaceholder={t('FLEXIBLE_WEBHOOK.SEARCH_PLACEHOLDER')}
			/>
			<span className="webhook-fields-reset-button" onClick={reset}>
				{t('FLEXIBLE_WEBHOOK.RESTORE_DEFAULT_DATA')}
			</span>
		</div>
	);
};

export default observer(WebhookFieldsForm);
